import Core from './core'
export default Core



// WEBPACK FOOTER //
// ./src/components/core/index.js